(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["frete"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shipping-estimate')) {
    class ShippingEstimate extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('.shipping-estimate__form');
        this.input = this.querySelector('.shipping-estimate__zip');
        this.results = this.querySelector('.shipping-estimate__results');
        this.status = this.querySelector('.shipping-estimate__status');
        this.variantPrices = this.readVariantPrices();
        this.form.addEventListener('submit', (event) => this.submit(event));
        this.input.addEventListener('input', () => this.formatZip());
      }

      readVariantPrices() {
        const data = this.querySelector('[data-variant-prices]');
        if (!data) return {};
        try {
          return JSON.parse(data.textContent);
        } catch (error) {
          return {};
        }
      }

      formatZip() {
        const digits = this.input.value.replace(/\D/g, '').slice(0, 8);
        this.input.value = digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
      }

      async submit(event) {
        event.preventDefault();
        const zip = this.input.value.replace(/\D/g, '');
        if (zip.length !== 8) {
          this.showError('Digite um CEP válido.');
          return;
        }

        const button = this.querySelector('.shipping-estimate__button');
        button.setAttribute('aria-busy', 'true');
        this.status.textContent = '';

        try {
          const response = await fetch(`https://viacep.com.br/ws/${zip}/json/`);
          if (!response.ok) throw new Error('address');
          const address = await response.json();
          if (address.erro) throw new Error('invalid');
          await this.updateOrderTotal();
          this.showResults(address);
        } catch (error) {
          this.showError('Não foi possível consultar este CEP. Confira os números e tente novamente.');
        } finally {
          button.removeAttribute('aria-busy');
        }
      }

      async updateOrderTotal() {
        if (this.dataset.context === 'product') {
          const productArea = this.closest('.product__info');
          const productForm = productArea ? productArea.querySelector(`form[id^="product-form-"]`) : null;
          const variantInput = productForm ? productForm.querySelector('[name="id"]') : null;
          const quantityInput = productArea ? productArea.querySelector('[name="quantity"]') : null;
          const variantId = variantInput ? variantInput.value : this.dataset.selectedVariantId;
          const variantPrice = Number(this.variantPrices[variantId] || this.dataset.selectedVariantPrice || 0);
          const quantity = Math.max(1, Number(quantityInput ? quantityInput.value : 1) || 1);
          this.projectedTotal = variantPrice * quantity;
          return;
        }

        this.projectedTotal = Number(this.dataset.cartTotal || 0);

        try {
          const cartUrl = `${window.Shopify.routes.root}cart.js?timestamp=${Date.now()}`;
          const response = await fetch(cartUrl, {
            credentials: 'same-origin',
            cache: 'no-store'
          });
          if (response.ok) {
            const cart = await response.json();
            this.projectedTotal = Number(cart.total_price || 0);
          }
        } catch (error) {
          this.projectedTotal = Number(this.dataset.cartTotal || 0);
        }
      }

      showResults(address) {
        const destination = this.querySelector('.shipping-estimate__destination');
        const place = [address.logradouro, address.bairro, address.localidade, address.uf].filter(Boolean).join(' - ');
        destination.innerHTML = `Entrega disponível para <strong>${this.escapeHtml(place)}</strong>`;
        this.updateFreeOption();
        this.results.hidden = false;
        this.status.textContent = '';
      }

      updateFreeOption() {
        const option = this.querySelector('[data-free-option]');
        if (!option) return;
        const price = option.querySelector('.shipping-estimate__price--free');
        const economyOption = this.querySelector('[data-economy-option]');
        const threshold = Number(this.dataset.freeShippingThreshold || 0);
        const eligible = threshold > 0 && this.projectedTotal >= threshold;
        price.textContent = eligible ? 'Grátis' : `Acima de ${this.formatMoney(threshold)}`;
        if (economyOption) economyOption.hidden = eligible;
      }

      formatMoney(cents) {
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
      }

      escapeHtml(value) {
        const element = document.createElement('span');
        element.textContent = value;
        return element.innerHTML;
      }

      showError(message) {
        this.status.textContent = message;
        this.results.hidden = true;
      }
    }

    customElements.define('shipping-estimate', ShippingEstimate);
  }
  } catch(e) { console.error(e); }
})();

})();
